/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react'
import MenuIcon from 'mdi-react/MenuIcon'

type TopbarSidebarButtonProps = {
  changeMobileSidebarVisibility: () => void
  changeSidebarVisibility: () => void
}

class TopbarSidebarButton extends React.PureComponent<
  TopbarSidebarButtonProps
> {
  render() {
    const {
      changeMobileSidebarVisibility,
      changeSidebarVisibility,
    } = this.props

    return (
      <div>
        <button
          className="topbar__button topbar__button--desktop"
          type="button"
          onClick={changeSidebarVisibility}
        >
          <MenuIcon />
        </button>
        <button
          className="topbar__button topbar__button--mobile"
          type="button"
          onClick={changeMobileSidebarVisibility}
        >
          <MenuIcon />
        </button>
      </div>
    )
  }
}

export default TopbarSidebarButton
